export default "__VITE_ASSET__DIRLtjV7__"